module.exports = __webpack_public_path__ + "img/layout_horizontal_crisscross.17b6216c.svg";